<template>
  <div class="container" style="padding-top: 50px">
    <!-- 面包屑导航 -->
    <Nav :navbar="navbar"></Nav>
    <div class="flex flex-x-between flex-y-start list-wrap">
      <!-- 快速导航 -->
      <News :columnList="columnList"></News>
      <!-- 列表 -->
      <div class="leader flex-box">
        <ul v-if="list.length > 0">
          <li
            class="flex flex-x-between flex-y-center"
            v-for="(item, index) in list"
            :key="index"
          >
            <span @click="detailHandle(item)">{{ item.strMasTitle }}</span
            ><i>{{ item.strPubDate }}</i>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
        <div
          class="page-wrap flex flex-x-center flex-y-center"
          v-if="list.length > 0"
        >
          <p @click="getListData(1, true)">首页</p>
          <p @click="getListData(intCurPage <= 1 ? 1 : intCurPage - 1, false)">
            上一页
          </p>
          <p
            @click="
              getListData(
                intCurPage >= intPageCount ? intPageCount : intCurPage + 1,
                false
              )
            "
          >
            下一页
          </p>
          <p @click="getListData(intPageCount, false)">尾页</p>
          <span
            >当前页：<i>{{ intCurPage }}</i
            >/{{ intPageCount }}</span
          >
          <div>
            跳转至<a-input
              :value="input_value"
              @change="changeHandle"
              @pressEnter="pressEnter"
            />页
          </div>
          <b @click="pressEnter()">跳转</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/base/nav.vue'
import News from '@/components/base/news.vue'
import { listData } from '@/api/configuration'
import { get } from '../../utils/helpers'
export default {
  name: 'List',
  components: {
    Nav,
    News
  },
  props: {},
  data() {
    return {
      strId: '',
      navbar: [], // 面包屑导航
      columnList: [], //侧边导航
      list: [], // 列表
      input_value: 1, // 跳转至默认值1
      intAllCount: 0, // 总条数
      intCurPage: 1, // 当前页
      intPageCount: 1 // 总页数
    }
  },
  watch: {
    $route(to, from) {
      this.getListData(1, true)
    }
  },
  created() {
    this.strId = this.$route.query.strId
    this.getListData(1, true)
  },
  methods: {
    //获取列表数据
    getListData(page, refresh) {
      var param = {
        strColId: this.$route.query.strId,
        strWebSiteId: this.$route.query.strWebSiteId,
        intCurPage: page
      }
      listData(param)
        .then((res) => {
          if (refresh) {
            this.columnList = get(['data', 'objList', 'columnList'], res.data) // 侧边导航
            this.list = get(['data', 'objList', 'infoList'], res.data) //列表
            this.intAllCount = get(['data', 'objList', 'intAllCount'], res.data)
            this.intCurPage = get(['data', 'objList', 'intCurPage'], res.data)
            console.log(this.intCurPage)
            this.intPageCount = get(
              ['data', 'objList', 'intPageCount'],
              res.data
            )

            //碎片导航
            this.navbar = []
            for (let i in res.data.data.objList.colPathList) {
              this.navbar.push(res.data.data.objList.colPathList[i])
            }
            this.navbar.splice(0, 1)
            // 设置title
            let length = this.navbar.length
            document.title = this.navbar[length - 1].strName
          } else {
            this.list = get(['data', 'objList', 'infoList'], res.data)
            this.intCurPage = get(['data', 'objList', 'intCurPage'], res.data)
            console.log('else')
          }
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(err)
        })
    },

    // 输入框点击
    changeHandle(value) {
      this.input_value = value.data
    },

    // 输入框按下Enter键
    pressEnter() {
      this.getListData(this.input_value, false)
    },

    // 跳转详情
    detailHandle(item) {
      if (item.strUrl) {
        window.open(item.strUrl, '_blank') //跳转至新页面
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            strId: item.strId,
            strWebSiteId: this.$route.query.strWebSiteId
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;
}
.list-wrap {
  margin: 8px auto;
}
.leader {
  border: solid 1px #ccc;
  box-sizing: border-box;
  padding: 12px 25px 22px;
  margin: 0 0 0 15px;
  ul {
    margin-bottom: 20px;
    li {
      box-sizing: border-box;
      padding: 0 6px 0 35px;
      font-size: 18px;
      color: #666;
      height: 42px;
      line-height: 42px;
      border-bottom: 1px dashed rgb(161, 161, 161);
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 15px;
        top: -4px;
        width: 5px;
        height: 5px;
        display: inline-block;
        background: #999;
        margin-top: 23px;
      }
      span {
        display: block;
        width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
        cursor: pointer;
        &:hover {
          color: #df3036;
        }
      }
      i {
        font-style: normal;
        font-size: 16px;
        color: #999;
      }
    }
  }
  .no-content {
    text-align: center;
    box-sizing: border-box;
    padding: 100px 0;
  }
  .page-wrap {
    color: #4a4a4a;
    font-size: 16px;
    span {
      margin: 0 5px;
      i {
        display: inline-block;
        font-style: normal;
      }
    }
    p {
      padding: 0 10px;
      color: #000;
      border: 1px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
      margin: 0 3px;
      line-height: 24px;
      font-size: 12px;
      &:hover {
        color: #405fb9;
      }
    }
    > div {
      margin: 0 5px;
      input {
        width: 60px;
        padding: 0 10px;
        color: #000;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;
        margin: 0 6px;
        height: 26px;
        line-height: 24px;
        font-size: 12px;
        :focus {
          border: 1px solid #dcdada !important;
        }
      }
    }
    b {
      font-weight: normal;
      margin-left: 10px;
      padding: 0 15px;
      color: #000;
      border: 1px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
      margin: 0 3px;
      line-height: 24px;
      font-size: 12px;
      background-color: #efefef;
      &:hover {
        color: #405fb9;
      }
    }
  }
}
</style>
